export class ResponseCartMonthlyRecurringFeeModel {
          unitPrice: number;
          currencyCode: string;
}
